import { computed } from '@vue/composition-api'
import store from '@/store'

export default function useMyStore() {
  const viewMode = computed({
    get: () => store.state.myStore.viewMode,
    set: v => {
      store.commit('myStore/UPDATE_VIEWMODE', v)
    },
  })

  const currentFolder = computed({
    get: () => store.state.myStore.currentFolder,
    set: v => {
      store.commit('myStore/UPDATE_CURRENT_FOLDER', { currentFolder: v })
    },
  })

  // eslint-disable-next-line camelcase
  // const selectedFiles_ids = computed({
  //   get: () => store.state.myStore.selectedFiles_ids,
  //   set: v => {
  //     console.log(v)
  //     store.commit('myStore/UPDATE_TOGGLE_SELECTEDIDS', { id: v })
  //   },
  // })

  const currentObject = computed({
    get: () => store.state.myStore.currentObject,
    set: v => {
      store.commit('myStore/UPDATE_CURRENT_OBJECT', { currentObject: v })
    },
  })

  const uploadMethod = computed({
    get: () => store.state.myStore.uploadMethod,
    set: v => {
      store.commit('myStore/UPDATE_UPLOAD_METHOD', { uploadMethod: v })
    },
  })

  return {
    viewMode,
    currentFolder,
    currentObject,
    uploadMethod,
    // selectedFiles_ids,
  }
}
